import { render } from "./DashboardTab.vue?vue&type=template&id=4d4cb61a"
import script from "./DashboardTab.vue?vue&type=script&lang=js"
export * from "./DashboardTab.vue?vue&type=script&lang=js"

import "./DashboardTab.vue?vue&type=style&index=0&id=4d4cb61a&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__